import type { JSONSchema } from '@plone/types';
import type { IntlShape } from 'react-intl';

export const ButtonSchemaEnhancerForGroup = (
  schema: JSONSchema & { addMessage: string },
  data: any,
  intl: IntlShape,
): JSONSchema => {
  // Remvove 'align' field from 'layout' fieldset if isGroup is true
  const fieldsets = (schema.fieldsets || []).map((fs: any) => {
    if (fs?.id === 'layout') {
      return {
        ...fs,
        fields: (fs?.fields || []).filter((f: string) => f !== 'align'),
      };
    }
    return fs;
  });

  return {
    ...schema,
    fieldsets,
    required: ['href', 'label', ...(data?.isCircle ? ['icon'] : [])],
  };
};
